<template>
  <div>
    <div class="maxbox">
      <div>
        <div class="top">
          <p>我的社区</p>
        </div>
        <div class="main">
          <button class="return" @click="goback">
            <img src="@/assets/images/left-arrow.png" alt="" />
          </button><br>

          <!-- 链上真实资产数据 -->
          <div class="asset-box">
            <p>可提现余额：{{ withdrawBalance }} SBS</p>
            <p>累计总收益：{{ totalAllProfit }} SBS</p>
            <p>一级总分佣：{{ totalLevelBonus.level1 }} SBS</p>
            <p>二级总分佣：{{ totalLevelBonus.level2 }} SBS</p>
            <p>3-10级总分佣：{{ totalLevelBonus.level3To10 }} SBS</p>
            <p>直推有效人数：{{ directReferCount }} 人</p>
            <p>10代团队总人数：{{ teamTotalNum }} 人</p>
          </div>

          <!-- 链上读取个人矿机持仓 -->
          <div class="machine-box">
            <p>我的矿机持仓</p>
            <div v-for="(item,idx) in userMachineList" :key="idx">
              批次{{idx+1}} | 类型{{item.type}} | 数量{{item.count}} | 剩余天数{{item.days}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { ethers } from "ethers";
import { contractAddress, contractABI } from "@/js/contract.js";

export default {
  name: "myteam",
  data() {
    return {
      withdrawBalance: "0.000000",
      totalAllProfit: "0.000000",
      totalLevelBonus: {
        level1: "0.000000",
        level2: "0.000000",
        level3To10: "0.000000"
      },
      directReferCount: 0,
      teamTotalNum: 0,
      userMachineList: [],
      provider: null,
      signer: null,
      contract: null
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async initWallet() {
      if (!window.ethereum) {
        alert("请先安装钱包插件");
        return false;
      }
      const accounts = await window.ethereum.request({ method: 'eth_accounts' });
      if (!accounts || accounts.length === 0) {
        alert("请先连接钱包");
        return false;
      }
      this.provider = new ethers.providers.Web3Provider(window.ethereum);
      await this.provider.send("eth_requestAccounts", []);
      this.signer = this.provider.getSigner();
      this.contract = new ethers.Contract(contractAddress, contractABI, this.signer);
      return true;
    },

    async getAllChainData() {
      try {
        let withdraw = await this.contract.getWithdrawableDividends();
        this.withdrawBalance = ethers.utils.formatUnits(withdraw, 6);

        let totalPro = await this.contract.getTotalDividends();
        this.totalAllProfit = ethers.utils.formatUnits(totalPro, 6);

        let l1 = await this.contract.getFirstLevelBonus();
        let l2 = await this.contract.getSecondLevelBonus();
        let l3 = await this.contract.getThirdToTenthLevelBonus();
        this.totalLevelBonus = {
          level1: ethers.utils.formatUnits(l1, 6),
          level2: ethers.utils.formatUnits(l2, 6),
          level3To10: ethers.utils.formatUnits(l3, 6)
        };

        this.directReferCount = Number(await this.contract.getDirectReferralCount());

        // 忽略多余返回字段
        let [types, counts, days] = await this.contract.getMyMachineInvestments();
        this.userMachineList = [];
        for (let i = 0; i < types.length; i++) {
          this.userMachineList.push({
            type: Number(types[i]),
            count: Number(counts[i]),
            days: Number(days[i])
          })
        }
      } catch (e) {
        console.error("链上数据读取失败", e);
        alert("数据读取失败，请检查钱包与网络");
      }
    },

    async getTeamTotalPeople() {
      try {
        this.teamTotalNum = Number(await this.contract.getUserTenLevelTeamTotal());
      } catch (err) {
        console.error("团队人数读取失败", err);
        this.teamTotalNum = 0;
      }
    }
  },
  async mounted() {
    const walletStatus = await this.initWallet();
    if (!walletStatus) return;
    await this.getAllChainData();
    await this.getTeamTotalPeople();
  }
};
</script>

<style scoped>
@import "@/assets/css/team.css";
@import "@/assets/css/style.css";
.main {
  padding-top: 50px;
  padding-bottom: 20px;
}
.asset-box,.machine-box{
  margin:15px;
  padding:15px;
  border:1px solid #eee;
  border-radius:8px;
}
</style>